import type { AxiosResponse } from 'axios';
import { api } from '@/services/api/main/axios';

export const putCustomMarkApiRequest = async (
  payload: Bemob.CustomMark,
): Promise<AxiosResponse<Bemob.Response<string>>> => {
  return api.put('custom-marks', payload);
};

export const putCustomMarkBasicApiRequest = async (
  path: string,
  payload: Bemob.CustomMarkBase,
): Promise<AxiosResponse<Bemob.Response<string>>> => {
  return api.put(`${path}/mark`, payload);
};
